import { FileUploadResponseList } from '@Models/upload.models';

export enum AttachmentType {
  Header = 'header',
  Footer = 'footer',
  Attachment = 'listOfAttachments',
}

export interface UploadStateAttachment {
  data: FileUploadResponseList;
  isLoading: boolean;
}

export interface UploadState {
  header: UploadStateAttachment;
  footer: UploadStateAttachment;
  listOfAttachments: UploadStateAttachment;
}

export interface UploadPayload {
  storeKey: AttachmentType;
  attachment: UploadStateAttachment;
}

export interface ResetUploadPayload {
  storeKey: AttachmentType | null;
}
